import { axiosInstance } from ".";

const DEMO_REQUESTS_PATH = "/demo_requests";

/** Pagination via response headers (Current-Page, Page-Items, Total-Count, Total-Pages). */
const getDemoRequestsList = async (params) =>
  await axiosInstance.get(DEMO_REQUESTS_PATH, { params });

/** Updates the `status` only (e.g. pending <-> contacted). */
const updateDemoRequest = async ({ id, data }) =>
  await axiosInstance.patch(`${DEMO_REQUESTS_PATH}/${id}`, data);

const deleteDemoRequest = async (id) =>
  await axiosInstance.delete(`${DEMO_REQUESTS_PATH}/${id}`);

export { getDemoRequestsList, updateDemoRequest, deleteDemoRequest };
